export const PendingSessionsModalName = 'PendingSessionsModal';
